import React, { useCallback } from 'react';
import { Table, Button, Tooltip, Card, Skeleton } from "antd";
import { EyeOutlined } from '@ant-design/icons';
import { formatMoney } from '../utils';

export default function BalanceteTable({
    loading,
    situacaoList,
    toggleModal
}) {

    const abrirRazaoTabela = (record) => {
        toggleModal('livroRazao', true, { contaId: record.id, context: 'tabela' });
    };

    const renderSaldoCell = useCallback((value, record) => {
        const isNegrito = record.level <= 2;
        const fontWeight = isNegrito ? 800 : 400;

        if (!value || Math.abs(value) < 0.01) {
            return (
                <span style={{ color: '#262626', fontSize: '13px', fontWeight }}>
                    0,00
                </span>
            );
        }

        const isDebito = value > 0;
        const suffix = isDebito ? 'D' : 'C';
        const suffixColor = isDebito ? '#0050b3' : '#d46b08';

        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    fontWeight,
                }}
            >
                <span style={{ color: '#262626', fontSize: '13px', fontWeight }}>
                    {formatMoney(value)}
                </span>

                <span
                    style={{
                        marginLeft: '6px',
                        width: '12px',
                        fontWeight,
                        color: suffixColor,
                        fontSize: '11px',
                    }}
                >
                    {suffix}
                </span>
            </div>
        );
    }, []);

    const renderMovimentoCell = useCallback((value, record) => {
        const isNegrito = record.level <= 2;
        const fontWeight = isNegrito ? 800 : 400;

        if (!value || Math.abs(value) < 0.01) {
            return (
                <span style={{ color: '#262626', fontSize: '13px', fontWeight }}>
                    0,00
                </span>
            );
        }

        return (
            <span style={{ color: '#262626', fontSize: '13px', fontWeight }}>
                {formatMoney(value)}
            </span>
        );
    }, []);

    if (loading) {
        return (
            <Card className="table-card premium-card" bordered={false} bodyStyle={{ padding: '24px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <Skeleton.Input active style={{ width: '100%', height: '32px' }} />
                    {Array.from({ length: 8 }).map((_, i) => (
                        <div key={i} style={{ display: 'flex', gap: '16px' }}>
                            <Skeleton.Button active style={{ flex: 3, height: '24px' }} />
                            <Skeleton.Button active style={{ flex: 1, height: '24px' }} />
                            <Skeleton.Button active style={{ flex: 1, height: '24px' }} />
                            <Skeleton.Button active style={{ flex: 1, height: '24px' }} />
                            <Skeleton.Button active style={{ flex: 1, height: '24px' }} />
                        </div>
                    ))}
                </div>
            </Card>
        );
    }
    const columns = [
        {
            title: 'Conta',
            dataIndex: 'nome',
            key: 'nome',
            width: 450,
            fixed: 'left',
            render: (text, record) => {
                const paddingLeft = record.level * 20;
                const isNaoLancamento = record.sn_lancamento === 'N';
                const fontWeight = isNaoLancamento || record.level <= 2 ? 800 : 400;
                const color = record.level === 0 ? '#000' : '#262626';

                return (
                    <div
                        style={{
                            paddingLeft,
                            display: 'flex',
                            alignItems: 'center',
                            fontWeight,
                        }}
                    >
                        <span
                            style={{
                                marginRight: 8,
                                fontWeight,
                                color: '#2f54eb',
                                fontSize: '12px',
                            }}
                        >
                            {record.codigo}
                        </span>

                        <span
                            style={{
                                fontWeight,
                                color,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {record.nome}
                        </span>
                    </div>
                );
            },
        },
        {
            title: 'Saldo Anterior',
            dataIndex: 'vlTotalSaldoInicial',
            key: 'saldoAnterior',
            align: 'right',
            width: 130,
            render: renderSaldoCell,
        },
        {
            title: 'Débitos',
            dataIndex: 'vlTotalDebitos',
            key: 'debitos',
            align: 'right',
            width: 130,
            render: renderMovimentoCell,
        },
        {
            title: 'Créditos',
            dataIndex: 'vlTotalCreditos',
            key: 'creditos',
            align: 'right',
            width: 130,
            render: renderMovimentoCell,
        },
        {
            title: 'Saldo Final',
            dataIndex: 'vlTotalSaldoFinal',
            key: 'saldoFinal',
            align: 'right',
            width: 130,
            render: renderSaldoCell,
        },
        {
            title: "Ações",
            key: "acao",
            width: 70,
            align: 'center',
            render: (_, record) => {
                const isAnalitica = (record.codigo || "").split(".").length >= 4;
                return isAnalitica ? (
                    <Tooltip title="Livro Razão">
                        <Button
                            type="text" size="small" icon={<EyeOutlined />}
                            onClick={() => abrirRazaoTabela(record)}
                            style={{ color: '#1890ff' }}
                        />
                    </Tooltip>
                ) : null;
            },
        }
    ];

    return (
        <Card className="table-card premium-card" bordered={false} bodyStyle={{ padding: 0 }}>
            <div style={{ width: '100%' }}>
                <Table
                    rowKey="codigo"
                    columns={columns}
                    dataSource={situacaoList}
                    pagination={false}
                    loading={loading}
                    size="small"
                    scroll={{ x: 1150 }}
                    onRow={() => ({ style: { height: 'auto' } })}
                    expandable={{ expandIcon: () => null }}
                    rowClassName={(record, index) =>
                        index % 2 === 0 ? "row-striped-premium" : "row-hover-premium"
                    }
                />
            </div>
        </Card>
    );
}
